module.exports = __webpack_public_path__ + "static/OneDotExt-BoldItalic.ca07423f.eot";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDotExt-BoldItalic.eot
// module id = 750
// module chunks = 114276838955818